<form [formGroup]="medicijnen">

    <div formArrayName="pgaMedicijnen">
        <div *ngFor="let item of pgaMedicijnen.controls; let i = index; "
             [formGroupName]="i" class="row">

            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Medicijnen' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >

            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijMedicijnen(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 icon="trash"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="pgaMedicijnen.length === 0">
    <snelstart-ui-button (click)="addRijMedicijnen()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Medicijnen
    </snelstart-ui-button>
</div>
<div *ngIf="pgaMedicijnen.length > 0">
    <snelstart-ui-button (click)="addRijMedicijnen()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Medicijnen toevoegen
    </snelstart-ui-button>
</div>



